export default __webpack_public_path__ + "static/media/logo-governo-horizontal-branca.233852fe.svg";